import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
export default class Beacon extends React.Component {

    onChange = (value) => {
        this.props.onChange("beaconUuid", value);
    }

    getBeacon = () => {
        if(!this.props.asset.beaconUuid) {
            return "";
        }

        return this.props.asset.beaconUuid;
    }

    render () {
        const {
            asset,
            editable
        } = this.props;
        
        const currentValue = this.getBeacon();

        return (
            <div className="asset-beacon">
                <div>
                    <label htmlFor="beacons-list">{strings.asset_beacon_label}</label>
                    <select id="beacons-list" value={currentValue} disabled={!asset.editing} onChange={(e) => this.onChange(e.target.value)}>
                        <option value="">{strings.asset_beacon_none}</option>
                        {this.props.beacons.map(beacon => (
                            <option key={beacon.beaconUuid} value={beacon.beaconUuid}>{beacon.btMac}</option>
                        ))}
                    </select>
                </div>
                {editable && 
                    <div className="beacons-list-shortcut">
                        <a href={`/${getCurrentLocale()}/account/beacons`} target='_blank' rel="noopener noreferrer">{strings.asset_shortcut_to_beacons_list}</a>
                    </div>
                }
            </div>
        )
    }
}

Beacon.propTypes = {
    beacons: PropTypes.array, // This should contain not-aasigned beacons + beacon for current assret if any
    asset: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};
